import { observer } from "mobx-react-lite"
import BlockBase from "./base"
import BlockState from "pages/scheme-editor/store/block"
import BlockInfo from "./base-info"
import { FormControlLabel, Checkbox } from "@mui/material"
import Select from "components/controls/select"
import InputBlock from "components/controls/input-block"

const BlockValue = observer(({ state }: { state: BlockState }) => {

  return (
    <BlockBase state={state}>
      <BlockInfo state={state}>
        <Select 
          {...state.dataProps("dataType", "string")}
          label="Тип данных" 
          options={[ "Текст", "Число", "Ссылка" ]} 
          keys={[ "string", "number", "link" ]}
          sx={{ mt: 1, mb: 1.5, flexDirection: "column", alignItems: "stretch", label: { fontWeight: 400, fontSize: 10, mb: 0.4 } }}
        />
        { (!state.data.dataType || state.data.dataType === "string") && (
          <FormControlLabel sx={{ mt: -0.5 }} control={<Checkbox {...state.checkboxProps('multiline')} />} label="В несколько строк" />
        )}
        <InputBlock 
          sx={{ mb: 1 }} 
          {...state.dataProps('maxSize')} 
          label={ state.data.dataType === "number"? "Макс. значение": "Макс. кол-во символов" } 
          placeholder="Не ограничено"
        />
      </BlockInfo>
    </BlockBase>
  )
})

export default BlockValue